import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import createPlotlyComponent from 'react-plotly.js/factory';
import PropTypes from 'prop-types';
import useResponsive from 'hooks/useResponsive';
import useReports from 'hooks/useReports';
import useFilterByDate from 'hooks/useFilterByDate';
import NoDataImage from 'assets/images/nodata.png';
import { observer } from 'mobx-react-lite';
import moment from 'moment';

import { withAuctionCore } from 'agent';

import UnitPreviewOverlay from 'components/UnitPreviewOverlay';
import ImageModal from 'components/ImageModal';
import useStores from 'hooks/useStore';
import {
  Container, ChartContainer, NoDataImageWrapper, LoadingText,
} from './styles';

const { Plotly } = window;
const Plot = createPlotlyComponent(Plotly);

const Charting = observer(({ auctioncore }) => {
  const {
    setReports,
  } = useReports(auctioncore);

  const { UIStore } = useStores();

  const {
    condition, chartData, setRange,
  } = UIStore;

  const [chartDataAvgSale, setChartDataAvgSale] = useState(null);
  const [chartDataCR, setChartDataCR] = useState(null);
  const [chartDataMiles, setChartDataMiles] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(UIStore.selectedStartDate);

  const [showUnitPreview, setShowUnitPreview] = useState(false);
  const [showImageCarousel, setShowImageCarousel] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const { isLargeView } = useResponsive();

  const handleToggleImageModal = () => {
    if (showImageCarousel) {
      setShowImageCarousel(false);
      setShowUnitPreview(true);
      return;
    }

    setShowImageCarousel(true);
    setShowUnitPreview(false);
  };

  const handlePlotClick = (e, index) => {
    // try {
    //   if (isLargeView && e.points[0].customdata[index]) {
    //     const vehicleId = e.points[0].customdata[index];
    //
    //     UIStore.setHighlightedUnit(vehicleId.toLowerCase());
    //     return;
    //   }
    //
    //   setShowUnitPreview(false);
    //   setPreviewData(null);
    //   setTimeout(() => {
    //     try {
    //       const vehicleId = e.points[0].customdata[5];
    //       const vehicle = ProReport.getValueGuideProReport.vehicleComparables.filter((item) => item.vehicleID.toLowerCase() === vehicleId.toLowerCase());
    //       if (e.points && e.points[0].customdata) {
    //         setShowUnitPreview(true);
    //         setPreviewData(vehicle[0]);
    //       }
    //     } catch (e) {
    //       console.log(e);
    //     }
    //   }, 500);
    // } catch (error) {
    //   setShowUnitPreview(false);
    //   setPreviewData(null);
    // }
  };

  useEffect(() => {
    if (!chartData) {
      return;
    }

    if (UIStore.selectedStartDate === 'Invalid Date') {
      return;
    }

    if (selectedDate === UIStore.selectedStartDate || isNaN(UIStore.selectedStartDate)) {
      return;
    }

    setSelectedDate(UIStore.selectedStartDate);
    const data = chartData;

    data.aspjs.layout.xaxis.rangeslider = null;
    const { aspjs, aspjsCr, aspjsMiles } = data;

    const newRange = [moment(UIStore.selectedStartDate).startOf('month').subtract(14, 'days').format('YYYY-MM-DD'), moment(UIStore.selectedEndDate).endOf('month').add(7, 'days').format('YYYY-MM-DD')];

    data.aspjs.layout.xaxis.range = newRange;
    setChartDataAvgSale(aspjs);
    setChartDataMiles(useFilterByDate(aspjsMiles, UIStore.selectedStartDate, UIStore.selectedEndDate));
    setChartDataCR(useFilterByDate(aspjsCr, UIStore.selectedStartDate, UIStore.selectedEndDate));
  }, [UIStore.selectedStartDate, UIStore.selectedEndDate]);

  useEffect(() => {
    console.log('chartdata changed', chartData)
    if (!chartData) {
      return;
    }

    const data = chartData;
    if (!data.aspjs) {
      return;
    }

    console.log('tom>, ', data)
    data.aspjs.layout.xaxis.rangeslider = null;

    const { aspjs, aspjsCr, aspjsMiles } = data;

    const dr = aspjs.data[1].x;

    // UIStore.setRange([dr[0], dr[dr.length - 1]]);
    setRange([moment().subtract(2, 'years'), dr[dr.length - 1]]);

    setChartDataAvgSale(aspjs);
    setChartDataMiles(useFilterByDate(aspjsMiles, UIStore.selectedStartDate, UIStore.selectedEndDate));
    setChartDataCR(useFilterByDate(aspjsCr, UIStore.selectedStartDate, UIStore.selectedEndDate));
  }, [chartData]);

  useEffect(() => {
    if (condition.length <= 0 || chartData) {
      return;
    }
    setIsLoading(true);

    setReports(condition, true, true, true)
      .then(() => setIsLoading(false));
  }, [condition]);

  if (!chartData?.aspjs && !isLoading) {
    return (
      <Container>
        <NoDataImageWrapper src={NoDataImage} border={0} alt="No data available" width="100%" />
      </Container>
    );
  }

  if (isLoading) {
    return (
      <Container>
        <LoadingText
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ repeat: Infinity, duration: 1 }}
        >
          Analyzing Historic Data Trends
        </LoadingText>
      </Container>
    );
  }

  return (
    <Container>
      <Carousel showThumbs={false} width={isLargeView ? '910px' : 'calc(100vw)'}>
        {chartDataAvgSale && (
        <ChartContainer>
          <Plot
            data={chartDataAvgSale.data}
            onClick={(e) => handlePlotClick(e, 5)}
            layout={{
              padding: 0,
              height: isLargeView ? null : 300,
              plot_bgcolor: '#fff',
              paper_bgcolor: isLargeView ? '#fff' : '#fff',
              autosize: true,
              showlegend: false,
              images: [{
                sizex: 0.15,
                sizey: 0.15,
                source: "'https://raw.githubusercontent.com/jakeander/NPA/main/npaLogo3.png'",
                x: 1,
                xanchor: 'right',
                xref: 'paper',
                y: 1.15,
                yanchor: 'top',
                yref: 'paper',

              }],
              xaxis: chartDataAvgSale.layout.xaxis,
              yaxis: chartDataAvgSale.layout.yaxis,
              title: chartDataAvgSale.layout.title,
              legend: chartDataAvgSale.layout.legend,
              template: chartDataAvgSale.layout.template,

              margin: {
                l: 0,
                r: isLargeView ? 20 : 10,
                b: 20,
                t: isLargeView ? 60 : 30,
                pad: 2,
              },
              font: {
                color: isLargeView ? '#000' : '#000',
              },
            }}
            useResizeHandler
            style={{ width: isLargeView ? '835px' : 'calc(100vw - 45px)' }}
            config={{
              modeBarButtonsToRemove: ['toImage'],
              // colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
              displayModeBar: false,
            }}
          />
        </ChartContainer>
        )}

        {chartDataCR && (
        <ChartContainer>
          <Plot
            data={chartDataCR.data}
            onClick={(e) => handlePlotClick(e, 7)}
            layout={{
              annotations: chartDataCR.layout.annotations,
              padding: 0,
              height: isLargeView ? null : 300,
              plot_bgcolor: '#fff',
              paper_bgcolor: '#fff',
              autosize: true,
              legend: chartDataCR.layout.legend,
              template: chartDataCR.layout.template,
              xaxis: {
                ...chartDataCR.layout.xaxis,
              },
              yaxis: chartDataCR.layout.yaxis,
              title: chartDataCR.layout.title,
              // sliders: chartData.aspjsCr?.layout.sliders,
              coloraxis: {
                colorbar: chartDataCR.layout.coloraxis.colorbar,
                colorscale: chartDataCR.layout.coloraxis.colorscale,
                showscale: false,
              },
              margin: {
                l: 0,
                r: isLargeView ? 20 : 10,
                b: 20,
                t: isLargeView ? 60 : 30,
                pad: 2,
              },
              font: {
                color: isLargeView ? '#000' : '#000',
              },
            }}
            useResizeHandler
            style={{ width: isLargeView ? '835px' : 'calc(100vw - 45px)' }}
            config={{
              modeBarButtonsToRemove: ['toImage'],
              colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
              displayModeBar: false,
            }}
          />
        </ChartContainer>
        )}

        {chartDataMiles && (
        <ChartContainer>
          <Plot
            data={chartDataMiles.data}
            onClick={(e) => handlePlotClick(e, 7)}
            layout={{
              annotations: chartDataMiles.layout.annotations,
              padding: 0,
              height: isLargeView ? null : 300,
              plot_bgcolor: '#fff',
              paper_bgcolor: '#fff',
              autosize: true,
              legend: chartDataMiles.layout.legend,
              template: chartDataMiles.layout.template,
              xaxis: chartDataMiles.layout.xaxis,
              yaxis: chartDataMiles.layout.yaxis,
              title: chartDataMiles.layout.title,
              sliders: chartDataMiles.layout.sliders,
              coloraxis: {
                colorbar: chartDataMiles.layout.coloraxis.colorbar,
                colorscale: chartDataMiles.layout.coloraxis.colorscale,
                showscale: false,
              },
              margin: {
                l: 0,
                r: isLargeView ? 20 : 10,
                b: 20,
                t: isLargeView ? 60 : 30,
                pad: 2,
              },
              font: {
                color: isLargeView ? '#000' : '#000',
              },
            }}
            useResizeHandler
            style={{ width: isLargeView ? '835px' : 'calc(100vw - 45px)' }}
            config={{
              modeBarButtonsToRemove: ['toImage'],
              colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
              displayModeBar: false,
            }}
          />
        </ChartContainer>
        )}
      </Carousel>

      <UnitPreviewOverlay
        setShowUnitPreview={setShowUnitPreview}
        setShowImageCarousel={handleToggleImageModal}
        show={showUnitPreview}
        values={previewData}
      />
      {previewData && previewData.pictureURLs && <ImageModal setShowImageCarousel={handleToggleImageModal} images={previewData.pictureURLs} visible={showImageCarousel} />}
    </Container>
  );
});

Charting.propTypes = {
  ProReport: PropTypes.object.isRequired,
};

export default withAuctionCore(Charting);
